import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { LauncherWindowData, useLauncherWindowStore } from '../../hooks/stores/launcherWindowStore';
import { UIData, useUIStore } from '../../hooks/stores/uiStore';

export const SnappingGrid = () => {
  const [UIData] = useUIStore<UIData>();
  const [launcherWindowData] = useLauncherWindowStore<LauncherWindowData>();
  const [isVisible, setIsVisible] = useState(false);
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const gridSize = UIData.snappingGridSize;
  const dotSize = 1;


  // Draw grid
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const rows = Math.ceil(launcherWindowData.windowHeight / gridSize);
    const columns = Math.ceil(launcherWindowData.windowWidth / gridSize);

    ctx.clearRect(0, 0, canvas.width, canvas.height);
    for (let col = 0; col <= columns; col++) {
      for (let row = 0; row <= rows; row++) {
        ctx.fillStyle = '#eeeeee';
        ctx.beginPath();
        ctx.arc(col * gridSize + dotSize, row * gridSize + dotSize, dotSize, 0, Math.PI * 2);
        ctx.fill();
        ctx.closePath();
      }
    }
  }, [gridSize, launcherWindowData.windowHeight, launcherWindowData.windowWidth]);

  // Set visibility
  useEffect(() => {
    const flags = UIData.elementHandle;
    if ((UIData.snapToGrid && (flags.isDragging || flags.isResizing)) || UIData.gridPreview) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  }, [UIData.elementHandle, UIData.snapToGrid, UIData.gridPreview]);

  return (
    <Container $isVisible={isVisible} style={{ translate: `-${dotSize}px -${dotSize}px` }}>
      <canvas
        ref={canvasRef}
        width={launcherWindowData.windowWidth + dotSize * 2}
        height={launcherWindowData.windowHeight + dotSize * 2}
      />
    </Container>
  );
};

const Container = styled.div<{ $isVisible?: boolean }>`
  pointer-events: none;
  position: absolute;
  top: 0;
  left: 0;

  transition: opacity var(--transition-2);
  ${({ $isVisible }) => !$isVisible && 'opacity: 0;'}
`;

const Dot = styled.div<{ $size?: number }>`
  position: absolute;
  width: ${({ $size }) => $size ?? 10}px;
  height: ${({ $size }) => $size ?? 10}px;
  translate: -50% -50%;

  border-radius: 50%;
  background-color: #eee;
  box-shadow: 0 0 3px 0.5px #0009;
`;
